module.exports = __webpack_public_path__ + "double-wdl-desktop.jpg";